import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';

import { Subscription } from 'rxjs';
import { environment } from "@env/environment";
import { MsalService } from '@azure/msal-angular';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

	deviceInfo: DeviceInfo;
	title = 'PRIS';
	getErrorMessagesSubscription: Subscription;
	currentEnv: string;

	public isAuthenticated: boolean = false;

	constructor(
		private deviceDetectorService: DeviceDetectorService,
		private router: Router,
		private msalService: MsalService,
		private changeDetectorRef: ChangeDetectorRef
	) {

		this.currentEnv = environment.name;
		this.deviceInfo = this.deviceDetectorService.getDeviceInfo();
	}

	ngOnInit(): void {
		this.checkBrowserCompatibility();
		this.checkAuthenticationStatus();
	}

	private checkBrowserCompatibility() {

		if (this.deviceInfo.browser != "Chrome" &&
			this.deviceInfo.browser != "Firefox" &&
			this.deviceInfo.browser != "MS-Edge" &&
			this.deviceInfo.browser != "MS-Edge-Chromium") {

			this.router.navigate(['browser-not-supported']);
		}
	}

	private checkAuthenticationStatus() {
		if (this.msalService.instance.getActiveAccount()) {
			this.isAuthenticated = true;
		} else {
			this.router.navigate(['/login']);
		}
	}

	public afterLogin() {
		// Force Angular to detect changes and update the authentication state
		this.isAuthenticated = !!this.msalService.instance.getActiveAccount();
		this.changeDetectorRef.detectChanges(); // Trigger change detection manually
	}
}
